import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { AuditContext } from "../../schema/types/auditctx/entity";

export const auditctxApi = createApi({
  reducerPath: "auditctxApi",
  baseQuery: customBaseQuery,
  tagTypes: ["AuditContext"],
  endpoints: (builder) => ({
    getAuditContext: builder.query<AuditContext, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "AuditContext", id: link }],
    }),
  }),
});

export const { useGetAuditContextQuery } = auditctxApi;
